<script setup lang="ts">
// Header balance readout — the player's available BMO, shown in the header on
// every page so the bankroll is always visible. Once the player is enrolled in
// cash DFS (a cash wallet exists on the session) the USD chip joins it, so both
// bankrolls are always visible side-by-side — but never read alike: each chip
// keeps its own unit + color, because the whole point of the $-chips is that
// play money and real money can't be confused. Hidden when signed out (the
// public scoreboard can be viewed without an account). Refreshes on mount so
// the numbers are current wherever the user lands.
const { user, refreshBalance } = useAuth()
const { fmtMoney, fmtUsdCents } = useClientFormat()
const balance = computed(() => user.value?.balance ?? null)
// no cash chip while the platform profile says under 18: the cashier is closed
// to them, so a "$0.00 cash" readout would be a door to nowhere
const cash = computed(() =>
  user.value?.cash_age_eligible === false ? null : (user.value?.cash || null))
// one call refreshes both wallets (/balance returns cash alongside BMO)
onMounted(() => { if (user.value) refreshBalance() })
</script>

<template>
  <div v-if="user" class="bal-group" title="your balance">
    <div class="bal">
      <span class="bal-amt mono">{{ fmtMoney(balance) }}</span><span class="bal-unit">BMO</span>
    </div>
    <div v-if="cash" class="bal cash">
      <span class="bal-amt mono">{{ fmtUsdCents(cash.available_cents ?? 0, 'USD') }}</span><span class="bal-unit">cash</span>
    </div>
  </div>
</template>

<style scoped>
.bal-group { display: inline-flex; align-items: stretch; gap: 6px; }
.bal { display: inline-flex; align-items: baseline; gap: 5px; padding: 6px 11px; border-radius: 9px;
  border: 1px solid var(--line); background: rgba(34, 26, 73, 0.6); white-space: nowrap; }
.bal-amt { font-weight: 700; font-size: 15px; color: var(--accent); }
/* same green the $ Cash chip uses on contest cards */
.bal.cash .bal-amt { color: #7be0a3; }
.bal-unit { font-size: 10px; color: var(--muted); }
</style>
